import {  Animation, Color3, HighlightLayer, Mesh, Scene, TransformNode } from "@babylonjs/core";
//import { View } from "./view";

export class AnimationHandler{

    public MeshesWithAnimations:TransformNode[] = [];
    public highlightLayer:HighlightLayer
    public interval:NodeJS.Timeout;
    private _scene: Scene;

    private _hotspot:boolean;
    private _hostpotColor:string="#FF0000";
    private _hotspotColor3:Color3 = new Color3(0,1,0);
    private _hotspotTime:number=2;
    

    constructor(scene: Scene)
    {
       this._scene = scene;
       Animation.AllowMatricesInterpolation = true;
    }

    public DrawHotSpot()
    {
        if(this.highlightLayer)
            this.RemoveHotSpot();
        this.highlightLayer = new HighlightLayer("hl1", this._scene);
        for(let i=0;i<this.MeshesWithAnimations.length;i++)
        {
            if(!this.highlightLayer.hasMesh(this.MeshesWithAnimations[i].getChildMeshes()[0] as Mesh))
            {
                this.highlightLayer.addMesh(this.MeshesWithAnimations[i].getChildMeshes()[0] as Mesh,this._hotspotColor3)
            }
        }
    }
    public RemoveHotSpot()
    {
        if(this.highlightLayer != null)
        {
            this.highlightLayer.dispose();
            this.highlightLayer = null;
            if(this.interval)
                delete this.interval
        }
    }
    public DrawHotSpotTimeout(timeout: number) {
        if (this.highlightLayer == null) {
            this.highlightLayer = new HighlightLayer("hl1", this._scene);
            for (let i = 0; i < this.MeshesWithAnimations.length; i++) {
                if (!this.highlightLayer.hasMesh(this.MeshesWithAnimations[i].getChildMeshes()[0] as Mesh)) {
                    this.highlightLayer.addMesh(this.MeshesWithAnimations[i].getChildMeshes()[0] as Mesh, this._hotspotColor3);
                }
            }
            this.interval = setTimeout(() => {
                this.highlightLayer.dispose();
            }, timeout);
        } else {
            for (let i = 0; i < this.MeshesWithAnimations.length; i++) {
                if (!this.highlightLayer.hasMesh(this.MeshesWithAnimations[i].getChildMeshes()[0] as Mesh)) {
                    this.highlightLayer.addMesh(this.MeshesWithAnimations[i].getChildMeshes()[0] as Mesh, new Color3(1, 1, 0.4));
                }
            }
            if (this.interval) {
                clearTimeout(this.interval); // Clear the existing timeout
            }
            this.interval = setTimeout(() => {
                this.highlightLayer.dispose();
            }, timeout); // Set a new timeout
        }
    }
    
    public DrawHotSpotColorTimeout(Color:Color3,timeout:number)
    {
        if(this.highlightLayer == null)
        {
            this.highlightLayer = new HighlightLayer("hl1", this._scene);
            for(let i=0;i<this.MeshesWithAnimations.length;i++)
                {
                    if(!this.highlightLayer.hasMesh(this.MeshesWithAnimations[i].getChildMeshes()[0] as Mesh))
                    {
                        this.highlightLayer.addMesh(this.MeshesWithAnimations[i].getChildMeshes()[0] as Mesh,Color)
                    }
                }
            this.interval = setTimeout(()=>{
                this.highlightLayer.dispose();
                },timeout)
        }
        else
        {
            for(let i=0;i<this.MeshesWithAnimations.length;i++)
            {
                if(!this.highlightLayer.hasMesh(this.MeshesWithAnimations[i].getChildMeshes()[0] as Mesh))
                {
                    this.highlightLayer.addMesh(this.MeshesWithAnimations[i].getChildMeshes()[0] as Mesh,Color)
                }
            }
            if(this.interval)
                this.interval.refresh();
        }
      
    }
    convertHex(hex: string): Color3
    {
            // Remove the hash at the start if it's there
        hex = hex.replace(/^#/, '');

        // Parse the r, g, b values
        const r = parseInt(hex.substring(0, 2), 16) / 255;
        const g = parseInt(hex.substring(2, 4), 16) / 255;
        const b = parseInt(hex.substring(4, 6), 16) / 255;

        // Return the Color4 object with alpha set to 1
        return new Color3(r,g,b);
    }
    public get HotSpot():boolean{return this._hotspot;}
    public set HotSpot(value:boolean)
    {
        this._hotspot = value
        if(this._hotspot)
            this.DrawHotSpot();
        else
            this.RemoveHotSpot();
    } 
    public get HotSpotColor():string{return this._hostpotColor;}
    public set HotSpotColor(value:string)
    {
        if(value)
        {
            if(this.highlightLayer)
                this.RemoveHotSpot();
            this.HotSpot=true
            this._hostpotColor = value
            this.DrawHotSpotColorTimeout(this.convertHex(value),this._hotspotTime)
            this._hotspotColor3=this.convertHex(value)
        }
    } public get HotSpotTimeout():number{return this._hotspotTime;}
    public set HotSpotTimeout(value:number)
    {
        if(value)
        {
            if(this.highlightLayer)
                this.RemoveHotSpot();
            this.HotSpot=true
            this._hotspotTime = value
            this.DrawHotSpotColorTimeout(this._hotspotColor3,this._hotspotTime)
        }
    }
}